import React, { useContext } from 'react';
import { ActualIconProps } from 'mobx/commonTypes';
import { useTheme } from '@mui/material/styles';
import { UiContext } from 'uiContext';
import { defaultSpacingPresets } from 'hooks/useGetSpacing';

export default function IconThunder({
  style,
  extColor,
  isAutoscallable = true,
  sizeKey = '32x32',
}: ActualIconProps) {
  const theme = useTheme();
  const fill = extColor || theme.palette.customBackgrounds.contrast;
  const {
    spacings: {
      icons: { [sizeKey]: size },
    },
  } = useContext(UiContext);

  const w = isAutoscallable ? size.w : defaultSpacingPresets.icons[sizeKey].w;
  const h = isAutoscallable ? size.h : defaultSpacingPresets.icons[sizeKey].h;

  return (
    <svg
      style={style}
      width={w}
      height={h}
      viewBox="0 0 32 32"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.3213 20.0161H15.1535L13.9666 24.293H15.9271L14.7401 28.2222L18.8173 22.7677H16.3916L17.3213 20.0161Z"
        fill="white"
      />
      <path
        d="M22.5397 8.24808C22.4904 8.24808 22.4429 8.25307 22.3936 8.25495C21.8466 5.94292 19.7744 4.22217 17.2956 4.22217C14.6889 4.22217 12.5342 6.12273 12.1265 8.61208C11.8012 8.5203 11.4591 8.46786 11.1057 8.46786C9.30188 8.46786 7.79466 9.7272 7.41068 11.4142C6.00023 11.9687 5 13.3379 5 14.945C5 17.0398 6.69765 18.7393 8.79177 18.7393H22.5403C25.438 18.7393 27.7844 16.3904 27.7844 13.4928C27.7844 10.5951 25.4374 8.24933 22.5403 8.24933L22.5397 8.24808Z"
        fill="white"
      />
    </svg>
  );
}
